import Icon from '@mui/icons-material/SpaceDashboard';
import { SvgIconPropsOverrides } from '../../../model/icon';

export default function DashboardIcon({ className = '', ...props }: SvgIconPropsOverrides) {
	return <Icon className={`${className}`} {...props} />;
}
